export default __webpack_public_path__ + "static/kasa_2-8c2f48b534a1110480c8e7773f443e24.png";